import * as service from "../service";
import type { ServiceResponse } from "../types";

export type BusinessPlanType = "monthly" | "yearly";

export type BusinessPlanResult = {
  plan_type?: BusinessPlanType | string;
  status?: string;
  /** ISO timestamp the free first year ends, null when the business pays from day one. */
  free_trial_end?: string | null;
  /** True while the free first year is still running. */
  is_promo?: boolean;
  monthly_price?: number;
  yearly_price?: number;
  /** ISO timestamp the current subscription period ends, null when inactive. */
  renews_on?: string | null;
  monthly_price_amount?: number;
  yearly_price_amount?: number;
  /** Rate snapshot stored on the plan row (HKD), the numbers the statement bills. */
  monthly_fee?: number;
  yearly_fee?: number;
  /** True when the business is one of the first 100 granted a free first year. */
  is_promo_first_100?: boolean;
  /** Plan queued for the next renewal, null when there is none. */
  pending_plan_type?: BusinessPlanType | string | null;
  /** True when the subscription is set to end at the end of the paid period. */
  cancel_at_period_end?: boolean;
  /** ISO start of the subscription, anchoring the 12-month minimum term. */
  subscription_started_at?: string | null;
  /** ISO end of the 12-month minimum term, null before the term is anchored. */
  minimum_term_end?: string | null;
  /** ISO date a cancellation is scheduled for (before the term end). */
  cancel_at?: string | null;
  /** Open late fee, or null/absent when there is none. */
  overdue?: {
    has_overdue: boolean;
    grace_period_end: string | null;
    amount_due_hkd: number | null;
    accrued_late_fee_hkd: number;
    days_charged: number;
  } | null;
  /** Mirrored card gate: "valid" or "invalid". */
  card_status?: string;
  /** "active" | "locked"; locked only once the subscription has ended. */
  access_status?: string;
  /** False when the server has no Stripe keys yet, so checkout cannot run. */
  gateway_configured?: boolean;
  [key: string]: any;
};

/**
 * Fetch the signed-in business' platform-fee plan plus the price book the
 * plan chooser renders.
 * Backend: GET /api/business/plan
 */
export const GetBusinessPlanAPI = async (): Promise<
  ServiceResponse<BusinessPlanResult>
> => {
  try {
    const resp = (await service.call(
      "GET",
      "api/business/plan",
      {},
    )) as ServiceResponse<BusinessPlanResult>;
    return resp;
  } catch (err) {
    console.error(`GetBusinessPlanAPI ${err}`);
    return { status: -1, error: err };
  }
};
